import { render, staticRenderFns } from "./BookingsOverviewTable.vue?vue&type=template&id=192622f1&scoped=true&"
import script from "./BookingsOverviewTable.vue?vue&type=script&lang=js&"
export * from "./BookingsOverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./BookingsOverviewTable.vue?vue&type=style&index=0&id=192622f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192622f1",
  null
  
)

export default component.exports